import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Input, Radio, Row } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { getUserInfo } from "../../utils/utils";

const BillingDetails = ({ setStep, handleBilling, billingDetails }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const user = getUserInfo();
  const [hasGst, setGST] = useState(false);

  useEffect(() => {
    form.setFieldsValue(
      billingDetails?.content?.length
        ? {
            ...billingDetails?.content[0],
            ...billingDetails?.content[0]?.billingAddresses[0],
          }
        : {
            ...user,
            name: user.firstName + " " + user.lastName,
            mobileNumber: user?.mobileNo?.replace(/[^\d+]/g, ""),
          }
    );
  }, [billingDetails, form, user]);

  return (
    <Form
      form={form}
      layout="vertical"
      className="d-flex flex-column gap-20 mt20"
      onFinish={(values) => {
        handleBilling(
          values,
          () => setStep(2),
          (fieldErrors) => {
            if (fieldErrors?.length) {
              fieldErrors?.map((err) =>
                form.setFields([
                  {
                    name: err.field,
                    errors: [err.message],
                  },
                ])
              );
            }
          }
        );
      }}
    >
      <Card style={{ width: 750 }} title="Billing contact">
        <Row className="justify-content-between">
          <Col xs={24} md={6}>
            <label className="fw-medium d-flex justify-content-end">
              Name<span className="text-error">*</span>
            </label>
          </Col>
          <Col xs={24} md={17}>
            <Form.Item
              name="name"
              className="mb15"
              rules={[
                {
                  required: true,
                  message: "Please enter your name.",
                },
              ]}
            >
              <Input className="common-input" />
            </Form.Item>
          </Col>
        </Row>
        <Row className="justify-content-between">
          <Col xs={24} md={6}>
            <label className="fw-medium d-flex justify-content-end">
              Company Name<span className="text-error">*</span>
            </label>
          </Col>
          <Col xs={24} md={17}>
            <Form.Item
              name="companyName"
              className="mb15"
              rules={[
                {
                  required: true,
                  message: "Please enter company name.",
                },
              ]}
            >
              <Input className="common-input" />
            </Form.Item>
          </Col>
        </Row>
        <Row className="justify-content-between">
          <Col xs={24} md={6}>
            <label className="fw-medium d-flex justify-content-end">
              Email Address<span className="text-error">*</span>
            </label>
          </Col>
          <Col xs={24} md={17}>
            <Form.Item
              name="email"
              className="mb15"
              rules={[
                {
                  required: true,
                  message: "Please enter email.",
                },
              ]}
            >
              <Input className="common-input" />
            </Form.Item>
          </Col>
        </Row>
        <Row className="justify-content-between">
          <Col xs={24} md={6}>
            <label className="fw-medium d-flex justify-content-end">
              Mobile<span className="text-error">*</span>
            </label>
          </Col>
          <Col xs={24} md={17}>
            <Form.Item
              name="mobileNumber"
              className="mb15"
              normalize={(value) =>
                value ? value.replace(/[^\d+]/g, "") : value
              }
              rules={[
                {
                  required: true,
                  message: "Please enter mobile number.",
                },
                {
                  pattern: /^\+?\d+$/,
                  message: "Only digits allowed, optional + at the start",
                },
              ]}
            >
              <Input className="common-input" />
            </Form.Item>
          </Col>
        </Row>
      </Card>
      <Card style={{ width: 750 }} title="Billing Address">
        <Row className="justify-content-between">
          <Col xs={24} md={6}>
            <label className="fw-medium d-flex justify-content-end">
              Country<span className="text-error">*</span>
            </label>
          </Col>
          <Col xs={24} md={17}>
            <Form.Item
              name="country"
              className="mb15"
              rules={[
                {
                  required: true,
                  message: "Please enter country.",
                },
              ]}
            >
              <Input className="common-input" />
            </Form.Item>
          </Col>
        </Row>
        <Row className="justify-content-between">
          <Col xs={24} md={6}>
            <label className="fw-medium d-flex justify-content-end">
              Address<span className="text-error">*</span>
            </label>
          </Col>
          <Col xs={24} md={17}>
            <Form.Item
              name="address"
              className="mb15"
              rules={[
                {
                  required: true,
                  message: "Please enter address.",
                },
              ]}
            >
              <Input.TextArea className="common-input" />
            </Form.Item>
          </Col>
        </Row>
        <Row className="justify-content-between">
          <Col xs={24} md={6}>
            <label className="fw-medium d-flex justify-content-end">
              City<span className="text-error">*</span>
            </label>
          </Col>
          <Col xs={24} md={17}>
            <Form.Item
              name="city"
              className="mb15"
              rules={[
                {
                  required: true,
                  message: "Please enter city.",
                },
              ]}
            >
              <Input className="common-input" />
            </Form.Item>
          </Col>
        </Row>
        <Row className="justify-content-between">
          <Col xs={24} md={6}>
            <label className="fw-medium d-flex justify-content-end">
              State/Province<span className="text-error">*</span>
            </label>
          </Col>
          <Col xs={24} md={17}>
            <Form.Item
              name="state"
              className="mb15"
              rules={[
                {
                  required: true,
                  message: "Please enter state/province.",
                },
              ]}
            >
              <Input className="common-input" />
            </Form.Item>
          </Col>
        </Row>
        <Row className="justify-content-between">
          <Col xs={24} md={6}>
            <label className="fw-medium d-flex justify-content-end">
              ZIP/Postal<span className="text-error">*</span>
            </label>
          </Col>
          <Col xs={24} md={17}>
            <Form.Item
              name="zipCode"
              className="mb15"
              rules={[
                {
                  required: true,
                  message: "Please enter ZIP/Postal.",
                },
              ]}
            >
              <Input className="common-input" />
            </Form.Item>
          </Col>
        </Row>
        <Row className="justify-content-between">
          <Col xs={24} md={6}></Col>
          <Col xs={24} md={17} className="d-flex align-items-center gap-20">
            <label
              style={{ marginBottom: 24 }}
              className="fw-medium d-flex justify-content-end"
            >
              Are you registered GSTIN
            </label>
            <Form.Item
              name="hasGst"
              rules={[
                {
                  required: true,
                  message: "Please enter ZIP/Postal.",
                },
              ]}
            >
              <Radio.Group
                options={[
                  { value: true, label: "Yes" },
                  { value: false, label: "No" },
                ]}
                onChange={(val) => {
                  setGST(val.target.value);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        {hasGst && (
          <Row className="justify-content-between">
            <Col xs={24} md={6}>
              <label className="fw-medium d-flex justify-content-end">
                GST Number<span className="text-error">*</span>
              </label>
            </Col>
            <Col xs={24} md={17}>
              <Form.Item
                name="gstNumber"
                className="mb15"
                rules={[
                  {
                    required: true,
                    message: "Please enter gst number.",
                  },
                ]}
              >
                <Input className="common-input" />
              </Form.Item>
            </Col>
          </Row>
        )}
      </Card>
      <div
        style={{ width: 750 }}
        className="d-flex justify-content-between align-items-center"
      >
        <Button
          type="text"
          className="text-theme fw-medium"
          onClick={() => {
            searchParams.delete("plan");
            navigate(`${location.pathname}?${searchParams.toString()}`);
            setStep(0);
          }}
        >
          <span className="fw-medium heading18px d-flex gap-10">
            <ArrowLeftOutlined /> Back{" "}
          </span>
        </Button>
        <Button type="primary" htmlType="submit" className="theme-btn">
          Next{" "}
        </Button>
      </div>
    </Form>
  );
};

export default BillingDetails;
